import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";

import { TranslateService } from "../../common/translate";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { SpinnerOverlayRef } from "../../common/spinner/spinner-overlay.ref";
import { SpinnerOverlayService } from "../../common/spinner/spinner-overlay.service";
import { SnackbarService } from "../../common/snackbar/snackbar.service";
import { GatewaysService } from "./gateways.service";
import { GatewayView } from "./gateway-view";

@Injectable()
export class GatewaysUiService {

	constructor(
		public translateService: TranslateService,
		public dialog: MatDialog,
		public overlay: SpinnerOverlayService,
		public service: GatewaysService,
		public snackbarService: SnackbarService
	) { }

	public async setActiveGateway(gateway: GatewayView, shouldBeActive: boolean): Promise<boolean>;
	public async setActiveGateway(gateway: "cloud"): Promise<boolean>;
	public async setActiveGateway(gateway: GatewayView | "cloud", shouldBeActive?: boolean): Promise<boolean> {
		let uuid: string;
		let label: string;
		if (gateway === "cloud") {
			shouldBeActive = true;
			uuid = "cloud";
			label = "Cloud";
		} else {
			uuid = gateway.uuid;
			label = gateway.label;
		}
		return new Promise<boolean>((resolve, reject) => {
			try {
				const dialogRef = this.dialog.open(ConfirmationDialogComponent);
				if (shouldBeActive) {
					dialogRef.componentInstance.message = this.translateService.translate(
						"gateway.activate.dialog.message",
						{
							label: label
						}
					);
					dialogRef.componentInstance.title = "gateway.activate.dialog.title";
					dialogRef.componentInstance.buttonAction = "sdp.label.activate";
				} else {
					dialogRef.componentInstance.message = this.translateService.translate(
						"gateway.deactivate.dialog.message",
						{
							label: label
						}
					);
					dialogRef.componentInstance.title = "gateway.deactivate.dialog.title";
					dialogRef.componentInstance.buttonAction = "sdp.label.deactivate";
				}
				dialogRef.componentInstance.buttonCancel = "sdp.label.cancel";
				dialogRef.afterClosed().subscribe(async (result: boolean) => {
					if (result) {
						let ref: SpinnerOverlayRef | undefined = undefined;
						try {
							ref = this.overlay.open();
							if (shouldBeActive) {
								await this.service.activateGateway(uuid);
							} else {
								await this.service.deactivateGateway(uuid);
							}
							resolve(true);
						} catch (error) {
							reject(error);
						} finally {
							if (!!ref) {
								ref.close();
							}
						}
					} else {
						// only cloud activates from the typeselect, so we would need to revert back to private
						// if the user cancels
						this.service.gatewayTypeSelect.emit("private");
						resolve(false);
					}
				});
			} catch (e) {
				// only cloud activates from the typeselect, so we would need to revert back to private
				// if an error occurs
				this.snackbarService.showErrorBar(e, { label: label });
				this.service.gatewayTypeSelect.emit("private");
				reject(e);
			}
		});
	}
}
